module.exports = __webpack_public_path__ + "img/wechat.b35afe5f.png";